import React, { useEffect, useMemo, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import styles from 'assets/jss/material-dashboard-pro-react/components/adminOnTheGoNewServicesStyle';
import DashboardNavbarLinks from 'components/Navbars/DashboardNavbarLinks';
import _ from 'lodash';
import { useHistory } from 'react-router-dom';
import { getLanguage } from 'utils/language/language';
import { ShortcutService } from 'services/shortcuts/shortcuts';
import Paper from '@material-ui/core/Paper';
import Box from '@material-ui/core/Box';
import config from 'utils/api/config';
import { env } from 'config/app.config';
import { AdminOnTheGoServices } from 'utils/api/models/shortcuts/adminOnTheGoServices';
import { hideLoadingIndicator, showLoadingIndicator } from 'redux/modules/api/loadingIndicator/actions';
import { useDispatch } from 'react-redux';
import { finalize } from 'rxjs/operators';
import { throwError } from 'rxjs/internal/observable/throwError';
import { BodySBold, HeadingMBold, HeadingSBold } from 'components/Typography/Typography';
import { translate } from 'components/Translation';

// @ts-ignore
const useStyle = makeStyles(styles);

interface IAdminOnTheGoNewServicesPageProps {
	match: {
		params: {
			accountId: string;
		};
	};
}

const AdminOnTheGoNewServices = ({ match }: IAdminOnTheGoNewServicesPageProps) => {
	let { accountId } = match.params;

	const classes = useStyle();

	const lang = getLanguage();
	const [fetchedAdminOnTheGoNewServices, setFetchedAdminOnTheGoNewServices] = useState<AdminOnTheGoServices>();
	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(showLoadingIndicator());
		ShortcutService.getAdminOnTheGoNewServices()
			.pipe(
				finalize(() => {
					dispatch(hideLoadingIndicator());
				})
			)
			.subscribe(
				({ response }) => {
					if (response) {
						setFetchedAdminOnTheGoNewServices({ ...response });
					}
				},
				(error) => throwError(error)
			);
		return () => {
			dispatch(hideLoadingIndicator());
		};
	}, [lang, dispatch]);

	const categories = useMemo(() => {
		return _.uniq(_.map(fetchedAdminOnTheGoNewServices?.options, (option) => option?.category));
	}, [fetchedAdminOnTheGoNewServices]);

	const history = useHistory();

	return (
		<>
			<div className={classes.container}>
				<div className={classes.header}>
					<div className={classes.logoWrapper}>
						<img src={'/logo-color.svg'} alt="logo" />
					</div>
					<DashboardNavbarLinks />
				</div>
				<div className={classes.headingWrapper}>
					<HeadingMBold disableMargin color="secondary-light">
						{translate('shortcuts.add.new.services')}
					</HeadingMBold>
				</div>
				<div>
					{(categories || []).map((category) => (
						<div key={category} className={classes.categoryWrapper}>
							<BodySBold color="secondary-light">{category}</BodySBold>
							<Box className={classes.boxStyle}>
								{_.map(
									_.filter(
										fetchedAdminOnTheGoNewServices?.options,
										(option) => option.category === category
									),
									(el) => (
										<Paper
											key={el.label}
											className={classes.paperStyle}
											elevation={0}
											onClick={() => {
												const newUrl = el.url.replace(/{accountId}/g, accountId);
												history.push(newUrl);
											}}
										>
											<div className={classes.iconContainer}>
												<img
													className={classes.icon}
													src={`${config.protocol[env]}${config.sources.omantelPortal[env]}${el.icon}`}
													alt={el.label}
												/>
											</div>
											<div className={classes.textWrapper}>
												<HeadingSBold disableMargin color="secondary-light">
													{el.label}
												</HeadingSBold>
											</div>
										</Paper>
									)
								)}
							</Box>
						</div>
					))}
				</div>
			</div>
		</>
	);
};

export default AdminOnTheGoNewServices;
